export default __webpack_public_path__ + "images/lock-3.a17f5d10dbd644bd4382452a5f58ae26.png";